// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fontSize[data-v-a76c0cc2],.input-container[data-v-a76c0cc2]{font-size:13.5px}.fontSize[data-v-a76c0cc2]{margin-bottom:5px}@media screen and (max-width:870px){.fontSize[data-v-a76c0cc2]{font-size:11px;margin-bottom:5px}}@media screen and (max-width:510px){.fontSize[data-v-a76c0cc2]{font-size:10px;margin-bottom:7px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
